export default {
    filterHashPagesInHistory(window) {
        let hashHistory = [window.location.hash];
        let historyLength = window.history.length;
        let hashChangesLength = 0;
        window.addEventListener("hashchange", function() {
            const hash = window.location.hash;
            const length = window.history.length;
            if (hashHistory.length && historyLength == length) {
                if (hashHistory[hashHistory.length - 2] == hash) {
                    hashHistory = hashHistory.slice(0, -1);
                    window.history.go(-hashChangesLength);
                } else {
                    hashHistory.push(hash);
                    hashChangesLength++;
                }
            } else {
                hashHistory.push(hash);
                historyLength = length;
                hashChangesLength++;
            }
        });
    }
};